import { Injectable } from '@angular/core';
import { DataService } from '../../../../Autofacets-Core/src/app/services/data.service';
import { GenericResponse } from '../business-entities/generic-response';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';

@Injectable({
  providedIn: 'root'
})

export class AppLinkDataService {
  constructor(private dataProvider: DataService) {
  }

  GetCheckInUrl(appointmentGuid: string): Promise<any> {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.GetCheckInUrl, appointmentGuid).toPromise();
  }
  AddTrackerLink(params: any): Promise<any> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.AddTrackerLink, params).toPromise();
  }
  GetTrackerLink(appointmentGuid: string): Promise<any> {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.GetTrackerLink, appointmentGuid).toPromise();
  }
  SendTrackerSms(appointmentGuid: string): Promise<any> {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.SendTrackerSms, appointmentGuid).toPromise();
  }
  SendCheckInSms(id: number): Promise<any> {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.SendCheckInSms, id).toPromise();
  }
}